import { posthog } from "./provider";

export function trackCtaClicked(
  location: string,
  label: string,
  task?: string,
) {
  posthog.capture(
    "marketing_cta_clicked",
    { location, label, ...(task ? { task } : {}) },
    { transport: "sendBeacon" },
  );
}
